export default "__VITE_ASSET__C1WTPw40__"